<template>
  <nav class="p-4 flex items-center border-b">
    <div
      class="w-10 h-10 bg-amber-50 rounded-2xl flex items-center justify-center border border-amber-100 group-hover:bg-amber-100 transition-colors">
      <span class="text-2xl">🌾</span>
    </div>
    <!-- <img src="/favicon-96x96.png" class="w-8 h-8 mr-2" alt="Logo" /> -->
    <span class="font-bold text-lg text-green-900">稻香村</span>
  </nav>

  <div class="bg-white text-gray-900 font-sans selection:bg-blue-100">

    <section class="relative px-6 pt-16 pb-24 max-w-7xl mx-auto text-center overflow-hidden">
      <div class="relative z-10">
        <span
          class="inline-block px-4 py-1.5 mb-6 text-xs font-black tracking-widest text-blue-700 bg-blue-50 rounded-full uppercase">
          無需額外裝機費
        </span>
        <h1 class="text-5xl md:text-7xl font-black tracking-tighter leading-[1.1] mb-8">
          你的手機，就是<br />
          <span class="text-transparent bg-clip-text bg-linear-to-r from-blue-700 to-cyan-700">最強大的點餐機</span>
        </h1>
        <p class="text-lg text-gray-700 max-w-2xl mx-auto mb-10 font-medium">
          只要連上網路，不論手機、平板、筆電，隨時隨地開啟你的餐飲生意。
        </p>
        <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            class="w-full sm:w-auto px-8 py-4 bg-blue-700 text-white rounded-2xl font-black text-lg hover:scale-105 transition-transform shadow-xl shadow-blue-100">
            第一個月免費，基本款月費 500 台幣
          </button>
        </div>
      </div>

      <div
        class="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-blue-50/50 rounded-full blur-3xl z-0 pointer-events-none">
      </div>
    </section>

    <section class="py-20 bg-gray-50 px-6 border-t border-gray-100">
      <div class="max-w-4xl mx-auto">
        
        <div class="text-center mb-16">
          <h2 class="text-3xl font-black tracking-tight mb-4">透明價格，拒絕層層剝皮</h2>
          <p class="text-gray-700 font-medium">沒有高額的系統年費，沒有硬體綁架，用最少預算升級數位門市。</p>
        </div>

        <div class="grid md:grid-cols-2 gap-8 items-stretch">
          
          <div class="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-200 flex flex-col justify-between opacity-80">
            <div>
              <h3 class="text-xl font-black text-gray-500 mb-2">市售傳統 POS 方案</h3>
              <p class="text-xs text-gray-400 mb-6">估算坊間一般硬體與開通費</p>
              
              <div class="space-y-4 text-sm font-medium text-gray-600">
                <div class="flex justify-between border-b border-gray-100 pb-3">
                  <span>專用 POS 主機硬體</span>
                  <span class="font-bold text-gray-800">$25,000 起</span>
                </div>
                <div class="flex justify-between border-b border-gray-100 pb-3">
                  <span>電子發票開通設定費</span>
                  <span class="font-bold text-gray-800">$</span>
                </div>
                <div class="flex justify-between border-b border-gray-100 pb-3">
                  <span>熱感應發票出單機</span>
                  <span class="font-bold text-gray-800">$</span>
                </div>
                <div class="flex justify-between border-b border-gray-100 pb-3">
                  <span>專用載具掃描槍</span>
                  <span class="font-bold text-gray-800">$</span>
                </div>
              </div>
            </div>

            <div class="mt-8 pt-6 border-t border-gray-100">
              <p class="text-xs text-gray-400 mb-1">預估首次建置成本</p>
              <p class="text-2xl font-black text-gray-400 line-through">NT$ 37,500+</p>
            </div>
          </div>

          <div class="bg-white p-8 rounded-[2.5rem] shadow-lg border-2 border-green-600 relative flex flex-col justify-between scale-100 md:scale-105">
            <div class="absolute -top-4 right-8 bg-green-600 text-white text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest">
              最省方案
            </div>
            
            <div>
              <h3 class="text-xl font-black text-green-700 mb-2">我們的輕量化方案</h3>
              <p class="text-xs text-gray-500 mb-6">免設備月租、免買主機，用滑算價格搞定結帳發票</p>
              
              <div class="space-y-4 text-sm">
                <div class="flex justify-between border-b border-green-50 pb-3">
                  <span class="font-bold text-gray-900">電子發票系統設定費</span>
                  <span class="font-black text-green-700">$3,600 (一次性)</span>
                </div>
                <div class="flex justify-between border-b border-green-50 pb-3">
                  <span class="font-bold text-gray-900">熱感應電子發票列印機</span>
                  <span class="font-bold text-gray-700">市售任何機型</span>
                </div>
                <div class="flex justify-between border-b border-green-50 pb-3">
                  <span class="font-bold text-gray-900">發票載具掃描</span>
                  <span class="font-bold text-gray-700">市售任何機型，或手動輸入免費</span>
                </div>
                <div class="flex justify-between border-b border-green-50 pb-3 text-gray-400">
                  <span>櫃檯收單 (自備筆電)</span>
                  <span>$ 0 免費開通</span>
                </div>
                <div class="flex justify-between border-b border-green-50 pb-3 text-gray-400">
                  <span>員工點餐 (自備手機)</span>
                  <span>$ 0 免費開通</span>
                </div>
              </div>
            </div>

            <div class="mt-8 pt-6 border-t border-green-100 bg-green-50 -mx-8 -mb-8 p-8 rounded-b-[2.3rem]">
              <p class="text-xs text-green-700 font-bold mb-1">建置開通全包價</p>
              <div class="flex items-baseline gap-2">
                <span class="text-3xl font-black text-green-700">NT$ 3,600</span>
                <span class="text-sm font-black text-green-600">+ 硬體設備與出單機</span>
              </div>
              <p class="text-[11px] text-gray-500 mt-2">＊無隱藏合約費用，筆電、手機直接變身點餐系統！</p>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="py-20 bg-white px-6 border-t border-gray-100">
      <div class="max-w-7xl mx-auto">
        
        <div class="text-center mb-16">
          <h2 class="text-3xl font-black tracking-tight mb-4">打破傳統，迎向更輕巧的開店體驗</h2>
          <p class="text-gray-700 font-medium">別再被沉重的硬體設備與維護成本綁架，我們幫你化繁為簡。</p>
        </div>

        <div class="grid md:grid-cols-2 gap-8 items-stretch">
          
          <div class="bg-gray-50 p-8 md:p-10 rounded-[2.5rem] border border-gray-200 flex flex-col justify-between opacity-80">
            <div>
              <div class="flex items-center gap-3 mb-8">
                <div class="w-10 h-10 bg-gray-200 text-gray-600 rounded-xl flex items-center justify-center">
                  <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </div>
                <h3 class="text-2xl font-black text-gray-500">傳統點餐系統</h3>
              </div>
              
              <ul class="space-y-6 text-gray-600 font-medium">
                <li class="flex items-start gap-3">
                  <span class="text-red-500 mt-1">✕</span>
                  <div>
                    <p class="font-bold text-gray-800">綁定專用 POS 機</p>
                    <p class="text-sm text-gray-500 mt-1">必須購買笨重又昂貴的專用主機，維修成本高，壞了就無法營業。</p>
                  </div>
                </li>
                <li class="flex items-start gap-3">
                  <span class="text-red-500 mt-1">✕</span>
                  <div>
                    <p class="font-bold text-gray-800">員工硬體限制多</p>
                    <p class="text-sm text-gray-500 mt-1">點餐機台數量有限，尖峰時刻員工常塞在櫃檯搶機器、手忙腳亂。</p>
                  </div>
                </li>
                <li class="flex items-start gap-3">
                  <span class="text-red-500 mt-1">✕</span>
                  <div>
                    <p class="font-bold text-gray-800">發票流失與耗時</p>
                    <p class="text-sm text-gray-500 mt-1">傳統發票對獎麻煩，且不支援數位載具掃描，結帳速度慢，顧客體驗差。</p>
                  </div>
                </li>
              </ul>
            </div>
            
            <div class="mt-8 pt-6 border-t border-gray-200 text-center text-sm font-bold text-gray-400">
              高昂的初期設備投入與維護費
            </div>
          </div>

          <div class="bg-white p-8 md:p-10 rounded-[2.5rem] shadow-xl border-2 border-blue-700 relative flex flex-col justify-between scale-100 md:scale-105">
            <div class="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-blue-700 text-white text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-md">
              RECOMMENDED
            </div>
            
            <div>
              <div class="flex items-center gap-3 mb-8">
                <div class="w-10 h-10 bg-blue-100 text-blue-700 rounded-xl flex items-center justify-center">
                  <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 class="text-2xl font-black text-blue-900">我們的點餐系統</h3>
              </div>
              
              <ul class="space-y-6 text-gray-700">
                <li class="flex items-start gap-3">
                  <span class="text-green-600 font-black mt-0.5 text-lg">✓</span>
                  <div>
                    <p class="font-black text-gray-900 text-lg">免買 POS 機，筆電即櫃檯</p>
                    <p class="text-sm text-gray-600 mt-1">櫃檯端完全不需另外購買昂貴 POS 機，只要一台筆電即可直接登入、流暢收單。</p>
                  </div>
                </li>
                <li class="flex items-start gap-3">
                  <span class="text-green-600 font-black mt-0.5 text-lg">✓</span>
                  <div>
                    <p class="font-black text-gray-900 text-lg">員工手機就是行動點餐機</p>
                    <p class="text-sm text-gray-600 mt-1">員工端直接用自己的手機就能協助顧客點餐，打破空間限制，走到哪點到哪。</p>
                  </div>
                </li>
                <li class="flex items-start gap-3">
                  <span class="text-green-600 font-black mt-0.5 text-lg">✓</span>
                  <div>
                    <p class="font-black text-gray-900 text-lg">完美整合電子發票與載具</p>
                    <p class="text-sm text-gray-600 mt-1">支援熱感應紙印電子發票，並具備 QR CODE 掃描發票載具功能，環保又快速。</p>
                  </div>
                </li>
              </ul>
            </div>
            
            <div class="mt-8 pt-6 border-t border-blue-100 text-center text-sm font-black text-blue-700 bg-blue-50/50 rounded-2xl py-3">
              零硬體門檻，即開即用，效率提升 200%
            </div>
          </div>

        </div>
      </div>
    </section>


    <section class="py-20 bg-gray-50 px-6">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-16">
          <h2 class="text-3xl font-black tracking-tight mb-4">櫃檯、廚房、老闆端，完美同步</h2>
          <p class="text-gray-700 font-medium">所有的資訊都在雲端即時流轉，沒有漏單風險。</p>
        </div>

        <div class="grid md:grid-cols-3 gap-8">
          <div class="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-100">
            <div class="w-12 h-12 bg-blue-100 text-blue-700 rounded-2xl flex items-center justify-center mb-6">
              <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor font-bold">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                  d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="text-xl font-black mb-3">櫃檯入單</h3>
            <p class="text-gray-700 text-sm leading-relaxed">介面如社群軟體般直覺，店員無需培訓即可上手。支援手機掃碼點餐，減少人力壓力。</p>
          </div>

          <div
            class="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-100 scale-105 ring-2 ring-blue-700 relative">
            <div
              class="absolute -top-4 right-8 bg-blue-700 text-white text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest">
              Real-time</div>
            <div class="w-12 h-12 bg-orange-100 text-orange-700 rounded-2xl flex items-center justify-center mb-6">
              <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                  d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
              </svg>
            </div>
            <h3 class="text-xl font-black mb-3">廚房顯示</h3>
            <p class="text-gray-700 text-sm leading-relaxed">系統自動分類菜品，依序排單，確保每一道菜都不會漏。 </p>
          </div>

          <div class="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-100">
            <div class="w-12 h-12 bg-green-100 text-green-700 rounded-2xl flex items-center justify-center mb-6">
              <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor font-bold">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                  d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
              </svg>
            </div>
            <h3 class="text-xl font-black mb-3">數據營收</h3>
            <p class="text-gray-700 text-sm leading-relaxed">老闆隨時隨地開啟手機觀看營收日報、銷售排行，掌握庫存資訊，做數據化的管理。 </p>
          </div>
        </div>
      </div>
    </section>

    <section class="py-24 px-6 max-w-4xl mx-auto">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-black tracking-tight italic">為什麼選擇我們？</h2>
      </div>
      <div class="space-y-4">
        <div v-for="(item, i) in features" :key="i"
          class="flex items-center justify-between p-6 bg-white border border-gray-100 rounded-3xl hover:border-blue-100 transition-colors shadow-sm">
          <div class="flex items-center gap-4">
            <div class="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center text-blue-700">
              <svg class="w-5 h-5 font-bold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span class="font-bold text-gray-700">{{ item }}</span>
          </div>
          <span class="text-[10px] font-black text-blue-700 uppercase tracking-tighter">Included</span>
        </div>
      </div>
    </section>



    <footer class="bg-gray-900 text-white py-20 px-6 text-center">
      <h2 class="text-4xl font-black mb-6 tracking-tight">準備好讓生意變輕鬆了嗎？</h2>
      <p class="text-gray-400 mb-10 font-medium">不需要專業工程師，3 分鐘開通，立即營業。</p>
      <section class="py-24 px-6 max-w-4xl mx-auto">
        <button @click="showQrCode"
          class="rounded-2xl border-2 border-amber-100 bg-white px-10 py-5 text-xl font-black text-gray-700 shadow-xl transition-all hover:border-amber-700 hover:bg-amber-50 active:scale-95">
          請點我，聯絡專員為您服務
        </button>
      </section>
      <div class="mt-16 pt-8 border-t border-gray-700 text-gray-700 text-xs font-bold uppercase tracking-[0.2em]">
        © 稻香村 版權所有
      </div>
    </footer>
  </div>
</template>

<script setup lang="ts">
const features = [
  "【極速開店】 不挑硬體，手機平板就是你的全功能櫃檯。",
  "【靈活跨界】 iOS/Android/Web 三棲，管理從此無死角。",
  "【零秒上手】 極簡設計，這可能是你用過最直覺的系統。",
  "【數位升級】 電子發票領銜，可選擇列印或寄信。",
  "【流量紅利】 訂位、外帶整合 Google Map，把地圖變成你的吸客利器！",
]
import Swal from 'sweetalert2'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const base64img = "data:image/png;base64,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"

const showQrCode = () => {
  Swal.fire({
    title: '掃描 LINE',
    text: '聯絡專員為您服務',
    imageUrl: base64img, // 直接放入 base64 變數
    imageWidth: 240,
    imageHeight: 240,
    imageAlt: 'Contact QR Code',
    confirmButtonText: t('common.ok'),
    confirmButtonColor: '#2563eb', // 使用你的藍色主色
    showCloseButton: true,
    // 讓彈窗更圓潤的樣式
    customClass: {
      popup: 'rounded-4xl',
      confirmButton: 'rounded-xl px-8 py-3 font-bold'
    }
  });
};

</script>

<style scoped>
/* 可根據專案需求添加字體或其他微調 */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');

.font-sans {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
</style>